const MarketingMenu = (props) => {
  return (
    <div id="marketing-menu">
      <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
        <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
      </div>
      <hr className="m-0" />
      <ul className="ps-2 py-2 d-md-block d-none sidebar mb-0" id="menu">
        <li className={props.active === 'dashboard' ? 'active' : ''}><a href="/dashboard"><i className="bi bi-house-door me-2" /> Dashboard</a></li>
        <li className={props.active === 'reports' ? 'active' : ''}><a href="/reports"><i className="bi bi-graph-up-arrow me-2" /> Reports</a></li>
        <li className={props.active === 'clients' ? 'active' : ''}><a href="/clients"><i className="bi bi-building me-2" /> Clients</a></li>
        <li className={props.active === 'leads' ? 'active' : ''}><a href="/leads"><i className="bi bi-crosshair me-2" /> Leads</a></li>
        <li className={props.active === 'opportunities' ? 'active' : ''}><a href="/opportunities"><i className="bi bi-gem me-2" /> Opportunities</a></li>
        <li className={props.active === 'quotations' ? 'active' : ''}><a href="/quotations"><i className="bi bi-file-earmark-text me-2" /> Quotations</a></li>
        <li className={props.active === 'salesorders' ? 'active' : ''}><a href="/salesorders"><i className="bi bi-cart-check me-2" /> Sales Orders</a></li>
        <li className={props.active === 'oices' ? 'active' : ''}><a href="/invoices"><i className="bi bi-receipt-cutoff me-2" /> Invoices</a></li>
        <li className={props.active === 'products' ? 'active' : ''}><a href="/products"><i className="bi bi-box-seam me-2" /> Products</a></li>
        <li className={props.active === 'users' ? 'active' : ''}><a href="/users"><i className="bi bi-people me-2" /> Users</a></li>
        <li><a className="text-danger" href="/logout"><i className="bi bi-door-open me-2" /> Logout</a></li>
      </ul>
    </div>
  );
};

export default MarketingMenu;
